import { render, staticRenderFns } from "./AddReminder.vue?vue&type=template&id=8653538a&scoped=true&"
import script from "./AddReminder.vue?vue&type=script&lang=js&"
export * from "./AddReminder.vue?vue&type=script&lang=js&"
import style0 from "./AddReminder.vue?vue&type=style&index=0&id=8653538a&scoped=true&lang=css&"
import style1 from "./AddReminder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8653538a",
  null
  
)

export default component.exports